import { render, staticRenderFns } from "./CardPoo.vue?vue&type=template&id=6da88fcb&"
import script from "./CardPoo.vue?vue&type=script&lang=js&"
export * from "./CardPoo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports